export const api = {
  esacPointVouchers: '/esac-point/vouchers',
  esacPointsRedemption: '/esac-point/redemptions/order',
  esacPointsRedemptionOrderDetail: '/esac-point/redemptions/detail',
  iTokenAccumulateCalculation: '/accumulate-calculation',
  esacPointsBalance: '/esac-point/redemptions/balance',
  esacPointsProduct: '/shop/product-and-kitting',
  esacPointsRedemptionCalculate: '/esac-point/redemptions/calculate',
  createEsacPointsRedemption: '/esac-point/redemptions',
  esacPointsPdfLink: '/esac-point/download',
}
